module.exports = {"id":"213718","name":"Bismar Acosta","rating":"71","photo":"./data/images/photos/1/213718.png","club":{"name":"SK Brann","logo":"./data/images/clubs/SKBrann.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BismarAcosta0.json
// module id = 605
// module chunks = 0